export const CASE_TABS = [
  {
    label: 'AI Case Details',
    value: 0
  },
  {
    label: 'Ticket Details',
    value: 2
  }
];

export const INTERNAL_CASE_TABS = [
  {
    label: 'AI Case Details',
    value: 0
  },
  {
    label: 'Relevant Data',
    value: 1
  },
  {
    label: 'SOC Case Details',
    value: 2
  }
];

export default CASE_TABS;
